import React from 'react';
import styled from 'styled-components';
import Card from '../../layout/Card';
import { UseInvoiceInvoice } from 'src/utils/api/Invoices';
import { formatPrice } from 'src/utils/Util';
import Button from 'src/elements/Button';
import usePopup from 'src/utils/hooks/usePopup';
import AddPayment from 'src/layout/popups/invoice/AddPayment';

export default function PaymentsCard({ invoice }: { invoice: UseInvoiceInvoice }) {

	const [open] = usePopup();

	function sort(a: any, b: any) {
		return new Date(b.payment_date).getTime() - new Date(a.payment_date).getTime();
	}

	return (
		<Style size="medium">
			<div className="row center">
				<div className="h3">Betalningar</div>
				<div className="spacer auto"></div>
				{invoice.leftToPay > 0 && <Button onClick={() => {
					open(<AddPayment invoice={invoice} />);
				}}>Skapa betalning</Button>}
			</div>
			<div className="spacer s"></div>

			<div className="table-wrapper">
				<table className="table" cellSpacing={0}>
					<thead>
						<tr>
							<th>Datum</th>
							<th>Summa</th>
							<th>Typ</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{invoice.payments?.sort(sort).map((payment) => (
							<tr key={payment.id}>
								<td>{new Date(payment.payment_date).toLocaleTimeString('sv-SE', {
									year: 'numeric',
									month: 'numeric',
									day: 'numeric',
									hour: 'numeric',
									minute: 'numeric',
								})}</td>
								<td>{formatPrice(Math.ceil(payment.amount))}</td>
								<td>{{
									'onsite_card': 'På plats - Kort',
									'onsite_cash': 'På plats - Kontant',
									'onsite_swish': 'På plats - Swish',
									'invoice_bank': 'Faktura - Inbetalning Bank',
									'invoice_swish': 'Faktura - Swish',
								}[payment.payment_method]}</td>
								<td></td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<div className="spacer l"></div>

			<div className="row center">
				<div className="h3">Hämtade objekt</div>
				<div className="spacer auto"></div>
			</div>
			<div className="spacer s"></div>

			<div className="table-wrapper">
				<table className="table" cellSpacing={0}>
					<thead>
						<tr>
							<th>Datum</th>
							<th>ID</th>
							<th>Artikel</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{invoice.items?.filter(item => item.delivered).map((item) => (
							<tr key={item.id}>
								<td>{new Date(item.delivered as string).toLocaleTimeString('sv-SE', {
									year: 'numeric',
									month: 'numeric',
									day: 'numeric',
									hour: 'numeric',
									minute: 'numeric',
								})}</td>
								<td>{item.readable_id}</td>
								<td>{item.name}</td>
								<td></td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

		</Style>
	);
}

const Style = styled(Card)`

	.table-wrapper {
		overflow-x: auto;

		table {
			width: 100%;

			thead {
				tr {
					th {
						text-align: left;
						padding: 0.5rem;
						border-bottom: 1px solid #b9b9b9;
					}
				}
			}

			tbody {
				tr {
					td {
						padding: 0.5rem;
						border-bottom: 1px solid #b9b9b9;
					}
				}
			}
		}
	}

`;
